import ResponsiveTypography from '@/components/ui/responsive-typography';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { Box, IconButton } from '@mui/material';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';

const GoBackComponent = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  const navigate = useNavigate();

  const handleGoToHomeClick = useCallback(() => {
    navigate('/');
  }, [navigate]);

  return (
    <Box
      display={'flex'}
      alignItems={'center'}
      sx={{ cursor: 'pointer', marginTop: 1, marginLeft: 1 }}
    >
      <IconButton onClick={handleGoToHomeClick} disableRipple>
        <KeyboardBackspaceIcon />
        <ResponsiveTypography sx={{ color: theme.palette.text.primary }}>
          {t('return_to_homepage')}
        </ResponsiveTypography>
      </IconButton>
    </Box>
  );
};

export default GoBackComponent;
